import api from '../config/api';
import { Game } from '../types';

export const gameService = {
  list: async (): Promise<Game[]> => {
    const res = await api.get('/api/games');
    return res.data;
  },

  getById: async (id: number): Promise<Game> => {
    const res = await api.get(`/api/games/${id}`);
    return res.data;
  },

  create: async (data: Partial<Game>): Promise<Game> => {
    const res = await api.post('/api/games', data);
    return res.data;
  },

  update: async (id: number, data: Partial<Game>): Promise<Game> => {
    const res = await api.put(`/api/games/${id}`, data);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/games/${id}`);
  },
};
